import type { PermissionsHelpPageKey } from '@/config/permissionsHelpCopy';
import { defineStore } from 'pinia';

/**
 * Painel lateral de ajuda — telas de Permissões (mesmo padrão do PCO / FullLayout).
 */
export const usePermissionsPageHelpStore = defineStore('permissionsPageHelp', {
    state: () => ({
        drawerOpen: false,
        helpKey: 'routes' as PermissionsHelpPageKey
    }),
    actions: {
        setHelpKey(key: PermissionsHelpPageKey) {
            this.helpKey = key;
        },
        openDrawer() {
            this.drawerOpen = true;
        },
        closeDrawer() {
            this.drawerOpen = false;
        }
    }
});
